import { RouteStepTypeSelect } from "@/shared/form/process-route-step-input/views/route-step-type-select";
import Form from "@/shared/form/form";
import Select from "@/shared/form/select";
import { RouteRoleSelect } from "@/shared/form/process-route-step-input/views/route-role-select";
import Dictionary from "@/shared/form/dictionary";
import { RouteRoleOptionFragment } from "gql/graphql";
import { PersonSelect } from "@/modules/common/entities/person/select";
import { Space } from "@/shared/layout/space";
import { useRouteStepType } from "@/shared/form/process-route-step-input/model/use-route-step-type";

export function ProcessRouteStepInput({
  listPath = [],
  itemPath,
  roles,
}: {
  listPath?: (string | number)[];
  itemPath: (string | number)[];
  roles?: RouteRoleOptionFragment[];
}) {
  const fullPath = [...listPath, ...itemPath];

  const { routeStepType, changeRouteStepType } = useRouteStepType({ fullPath });

  return (
    <>
      <Space.Compact block>
        <Form.Item className={"grow"} style={{ width: "30%" }}>
          <RouteStepTypeSelect
            value={routeStepType}
            onChange={changeRouteStepType}
          />
        </Form.Item>

        <Form.Item
          className={"grow"}
          hidden={routeStepType !== undefined}
          style={{ width: "100%" }}
        >
          <Select disabled />
        </Form.Item>

        {routeStepType === "role" && (
          <Form.Item
            className={"grow"}
            name={[...itemPath, "role"]}
            hidden={routeStepType !== "role"}
            rules={[{ required: true }]}
            style={{ width: "100%" }}
          >
            {roles ? (
              <RouteRoleSelect roles={roles} />
            ) : (
              <Dictionary dictionary="HrRole" valueKey="code" />
            )}
          </Form.Item>
        )}

        {routeStepType === "person" && (
          <Form.Item
            className={"grow"}
            name={[...itemPath, "person"]}
            hidden={routeStepType !== "person"}
            rules={[{ required: true }]}
            style={{ width: "100%" }}
          >
            <PersonSelect />
          </Form.Item>
        )}
      </Space.Compact>
    </>
  );
}
